// Centralized Firebase configuration (loaded from CRA env vars)
//
// IMPORTANT (CRA): all exposed client-side env vars must start with REACT_APP_
// Values come from `.env.local` (ignored) or from your deployment env.

export function getFirebaseConfig() {
  const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };

  // Helpful dev-time warning if you forgot to fill out .env.local
  const required = [
    "apiKey",
    "authDomain",
    "projectId",
    "storageBucket",
    "messagingSenderId",
    "appId",
  ];

  const missing = required.filter((k) => !config[k]);
  if (missing.length) {
    // Don't hard-fail: we want the app to still load.
    // But Firebase will fail to initialize until these are set.
    // eslint-disable-next-line no-console
    console.warn(
      `[firebase] Missing env vars for: ${missing.join(", ")}. ` +
        "Create a .env.local file (see .env.example)."
    );
  }

  return config;
}
